import React from 'react';
import { AkHead } from '../AkHead';
import { env } from '@admitkard/uiutils/env';
import { ff } from '@admitkard/uiutils/featureFlags';
import { Button } from '@admitkard/ccl/Button';
import { careerCss } from 'components/Career/Career.css';
import { News } from 'components/Career/News';
import { Jobs } from 'components/Career/Jobs';
import { Stories } from 'components/Career/Stories';
import { Work } from 'components/Career/Work';

const Career: React.FunctionComponent = () => {

  return (
    <>
      <AkHead
        title="Career Page"
      />
      <div className="career-page-wrapper">

        {/* landing section */}
        <div className='career-page-section__landing'>
          <div className='section-landing-text'>
            <div className='landing-heading font-f'>
              Explore Endless
              <br /> Opportunities.
            </div>
            <div className='landing-heading-secondary font-f'>
              Looking to give your career the much need boost? <br />
              Join our team and be a part of a dynamic , ever-growing Ed-Tech organization.
            </div>
            <div className='apply-btn'>
              <a href="#apply-here" >
                <Button key="ok" variant="contained" color="primary" >
                  Apply with us
                </Button>
              </a>
            </div>
          </div>
          <div className='landing-section-img'>
            <div>
              <img className='img-mobile' src={env.getAssetUrl('images/career-page/first_fold_image_(mobile).png')} alt='mobile image' />
              <img className='img-web' src={env.getAssetUrl('images/career-page/first_fold_image.png')} alt="landing-page-image" />
            </div>
          </div>
        </div>

        <Jobs />

        {/* why AdmitKard */}
        <div className='why-wrapper'>
          <div className="why-container-first">
            <div className="why-container-img">
              <img className='img-mobile' src={env.getAssetUrl('images/career-page/second_fold_image_(mobile).png')} alt="..." />
              <img className='img-web' src={env.getAssetUrl('images/career-page/second_fold_image_(web).png')} alt="..." />
            </div>
          </div>
          <div className="why-container-second">
            <div className="why-h1 font-f">Why AdmitKard ?</div>
            <div className="why-text-secondary why-sec-helper" >
              We are a team of motivated professionals who share a strong sense of vision and
              leave no stone unturned in impelling educational outcomes.
            </div>

            <div className='why-secondary-block'>
              <div className='font-f why-sec-blk-helper'>We are assertive.</div>
              <div className="why-text-secondary why-txt-helper">
                Because we believe in creating an interactive environment to express your opinions clearly.
              </div>
              <div className='font-f why-sec-blk-helper'>
                We are not hesitant to present the best outcomes.
              </div>
              <div className="why-text-secondary why-txt-helper">
                When it comes to achieving success; we are ruthless in doing the right thing.
              </div>
              <div className="font-f why-sec-blk-helper ">We embrace unique outlooks and creative diversity.</div>
              <div className="why-text-secondary why-txt-helper" >Because life would be darn boring otherwise.</div>
            </div>
          </div>
        </div>

        {/* culture */}
        <div>
          <div className='culture-h1 font-f' >
            People and Culture
          </div>
          <div className='culture-content-wrapper'>
            <div className="culture-content-first">
              <div >
                <img className='img-mobile' src={env.getAssetUrl('images/career-page/third_fold_image_(mobile).png')} alt="..." />
                <img className='img-web' src={env.getAssetUrl('images/career-page/Third_fold_image_(web).png')} alt="..." />
              </div>
            </div>
            <div className='culture-content-second'>
              <div className='culture-content-second-text'>
                At AdmitKard corporate culture doesn’t set the standards for their employees.
                The employees collectively standardize a good work culture. We are people oriented,
                team oriented and at last outcome oriented. We support innovations and ideas and promote work
                life balance at the same time. The work culture here lays out a peaceful environment which boosts productivity.
              </div>
            </div>
          </div>
        </div>

        <Work />

        <News />

        <Stories />

        {/* Apply now */}
        <div className='apply-wrapper' id='apply-here'>
          <div className='apply-left'>
            <div className='apply-img'>
              <img className='apply-img-mobile'
                src={env.getAssetUrl('images/career-page/sixth_fold_image_(mobile).png')} alt='Apply-mobile' />
              <img className='apply-img-web' src={env.getAssetUrl('images/career-page/sixth_fold_image_(web).png')} alt="Apply-web" />
            </div>
          </div>
          <div className='apply-right'>
            <div className='apply-header-wrapper' >
              <div className='flex-align-center'>
                <div className='apply-border-head'></div>
                <div className="apply-text-heading">Drive Your Career</div>
              </div>
              <div className='apply-now-text'>Apply Now!</div>
            </div>
            <div className='apply-content'>
              Open Gateway to Your Next Adventure. <br />
              Upload your resume, CV, and portfolio here.
            </div>

            <div className='apply-btn'>
              {
                ff.isEnabled('is_hiring') ? (
                  <Button
                    onClick={() => window.open(`https://docs.google.com/forms/d/e/1FAIpQLSfEU4aahU-
                      kjoPbvUC6mHRiZLlWvoiAJH0KDsBvOW569bW9gw/viewform?vc=0&c=0&w=1&flr=0`)}
                    key="ok" variant="contained" color="primary" >
                      Upload Your CV
                  </Button>

                ): (
                  <div className='apply-text-heading' style={{margin: 'auto'}}>We are currently not hiring.</div>
                )
              }
            </div>
          </div>
        </div>
      </div>
      <style jsx>{careerCss}</style>
    </>
  );
};

export { Career };
